
    import {Options} from 'vue-class-component';
    import {Vue} from 'vue-property-decorator';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';

    @Options({
        components: {
            StepItemTitle,
        },
    })
    export default class AskForRecommendation extends Vue {
        $refs!: {
            recoText: HTMLTextAreaElement;
        };
        dataHeapTooltipID = 'profile-creation-tooltip-recommendations';

        mounted(): void {
            this.bottomSheetDisplayer = new BottomSheetDisplayer(
                '#completion-recommendations-bottom-sheet',
                this.dataHeapTooltipID,
                this.$el,
                'div.profile-creation-wizard',
            );
            this.$refs.recoText.value = this.defaultRecoText;
            this.emitRecoText({target: {value: this.defaultRecoText}});
            this.bottomSheetDisplayer.mounted();
        }

        openBottomSheet(): void {
            this.bottomSheetDisplayer.openBottomSheet();
        }

        emitRecoEmails(e: any): void {
            this.$emit('emailsChanged', e.target.value);
        }

        emitRecoText(e: any): void {
            this.$emit('textChanged', e.target.value);
        }

        get defaultRecoText(): string {
            return this.$msg('recommendation.defaultAskMessage');
        }

        get recoTextToSendJs(): string {
            return `{
                'm-textarea': {
                    autogrow: true,
                    displayCounter: true,
                    min: 0,
                    max: 2000
                }
            }`;
        }
    }
